var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDraw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 47,
    viewBox: "0 0 160 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49208 41.2702C25.4343 40.9175 45.6026 35.0212 57.9164 15.3601C62.0616 8.74164 63.1821 -1.89846 50.5715 2.85772C38.8572 7.27586 33.5733 23.6609 38.9344 33.5385C46.9795 48.3616 67.4112 47.6935 82.8779 42.9007C106.807 35.4856 130.081 26.2317 150.948 13.2708C155.199 10.6308 123.036 7.86491 133.835 10.0514C141.457 11.5947 148.27 11.1339 156.002 10.5931C161.571 10.2038 158.127 12.1297 155.07 14.842C150.103 19.2502 145.398 26.1364 144.129 32.342",
    stroke: "#2563EB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDraw);
export default __webpack_public_path__ + "static/media/arrowDraw.d95169c032ecaa3e72e92e81eeac2e75.svg";
export { ForwardRef as ReactComponent };